import React from "react";
import i18n from "@microdoing/shared/i18n";
import { useDispatch, useSelector } from "react-redux";
import { getStepFeedbacks } from "@microdoing/shared/services/userCampaign/selectors";
import ReviewCircleStat from "./ReviewCircleStat";
import { useEffect } from "react";
import { getReviewsRequest } from "@microdoing/shared/services/userCampaign/actions";
import { useMemo } from "react";
import { Box, PressableOpacity } from "app/components/common";
import theme from "app/Theme/Theme";
import { useNavigation } from "@react-navigation/native";

interface IProps {}

const CampaignReviews = ({}: IProps) => {
  const reviews = useSelector(getStepFeedbacks);

  const dispatch = useDispatch();
  const navigation = useNavigation();

  useEffect(() => {
    dispatch(getReviewsRequest());
  }, [dispatch]);

  const handleSeeReviews = () => {
    navigation.navigate("HistoricalList");
  };

  const numberOfReviewsValidated = useMemo(() => {
    return reviews.filter(review => review.isReviewValidated).length;
  }, [reviews]);

  const numberOfReviews = useMemo(() => {
    return reviews.length;
  }, [reviews]);

  const numberOfWaitingReviews = useMemo(() => {
    return numberOfReviews - numberOfReviewsValidated;
  }, [numberOfReviews, numberOfReviewsValidated]);

  return (
    <PressableOpacity onPress={handleSeeReviews} testID="reviews-box">
      <Box
        paddingHorizontal="xm"
        alignItems="center"
        justifyContent="space-between"
        flexDirection="row"
      >
        <ReviewCircleStat
          progress={1}
          number={numberOfReviews}
          color={theme.colors["brand.500"]}
          legend={i18n.t("submitted")}
        />
        <ReviewCircleStat
          progress={
            numberOfReviews ? numberOfWaitingReviews / numberOfReviews : 0
          }
          color={theme.colors["system.orange.900"]}
          number={numberOfWaitingReviews}
          legend={i18n.t("waiting")}
        />
        <ReviewCircleStat
          progress={
            numberOfReviews ? numberOfReviewsValidated / numberOfReviews : 0
          }
          color={theme.colors["system.green.900"]}
          number={numberOfReviewsValidated}
          legend={i18n.t("corrected")}
        />
      </Box>
    </PressableOpacity>
  );
};

export default CampaignReviews;
